import React from "react";

const CommonSendVia = ({
  isOpen,
  onClose,
  title = "Send Voucher via",
  options = [
    // "Whatsapp",
    // "SMS",
    "EMAIL",
    "Print",
  ],
  value = [],
  onChange,
  onConfirm,
  onPrint,
  singleSelect = false,
}) => {
  if (!isOpen) return null;

  const toggleOption = (option) => {
    let updated;
    if (value.includes(option)) {
      updated = value.filter((o) => o !== option);
    } else if (singleSelect) {
      updated = [option];
    } else {
      updated = [...value, option];
    }
    onChange(updated);
  };

  const handleConfirm = async () => {
    const selectedOption = value?.[0];

    if (selectedOption === "Print" && onPrint) {
      const shouldClose = await onPrint(value);
      if (shouldClose !== false) {
        onChange([]);
        onClose();
      }
      return;
    }

    const shouldClose = await onConfirm?.(value);
    if (shouldClose !== false) {
      onChange([]);
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50">
      <div className="bg-gray-900 p-6 rounded-lg w-96 text-white shadow-xl">
        {/* Title */}
        <h2 className="text-lg font-semibold mb-4">{title}</h2>

        {/* Options */}
        <div className="flex flex-col gap-3 mb-6">
          {options.map((option) => {
            const isChecked = value.includes(option);
            return (
              <div
                key={option}
                className="flex items-center justify-between bg-gray-800 rounded px-4 py-2 cursor-pointer hover:bg-gray-700 transition"
                onClick={() => toggleOption(option)}
              >
                <span>{option}</span>
                <div
                  className={`w-5 h-5 border-2 rounded-sm flex items-center justify-center ${
                    isChecked
                      ? "border-green-500 bg-green-500"
                      : "border-gray-400"
                  }`}
                >
                  {isChecked && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-3 w-3 text-black"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 00-1.414 0L8 12.586 4.707 9.293a1 1 0 10-1.414 1.414l4 4a1 1 0 001.414 0l8-8a1 1 0 000-1.414z"
                        clipRule="evenodd"
                      />
                    </svg>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        {/* Action Buttons */}
        <div className="flex justify-between gap-3">
          <button
            onClick={onClose}
            className="flex-1 bg-red-500 hover:bg-red-600 text-white py-2 rounded"
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            className="flex-1 bg-yellow-500 hover:bg-yellow-600 text-black py-2 rounded font-medium"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default CommonSendVia;
